export const sassMain = `
@import "variables";
@import "base";
@import "horizontal";
@import "interstitialLandscape";

/*
@import "one";
$link: url('{{Offers[0].ImageUrl or ""}}');

body{
    height: 100%;
    width: 100%;
    background-image: $link;
    background-size: cover;
    background-repeat: no-repeat;
}
*/

`

export const sassBase = `

html {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
}

*, *:before, *:after {
  box-sizing: inherit;
}

body {
  height: 100%;
  width: 100%;
  margin: 0;
  font-family: 'Quicksand', sans-serif;
  overflow: hidden;
}

section {
  background: #FAFAFA;
  padding: 0.01px;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top:0;
  left:0;
}

article {
  background-color: none;
  width: 90vw;
  display: block;
  position: absolute;
  left:4vw;
  top:20vh;
  height:29vh;
  color: #222222;

  figure{
    height:40vw;
    width: 40vw;
    position: absolute;
    left:0;
    background-image: url('{{Offers[0].ImageUrl or ""}}');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    margin:0;
  }

  header {
    position: absolute;
    bottom: 0;
    right: 0;
    top:0;
    height:auto;
    width: 45vw;
    font-size: 4vw;
    line-height: 4.5vw;
    font-weight:600;
    color: #222;

    .wrap{
      position: absolute;
      left: 50%;
      transform: translate(-50%,0%);
      width:100%;
      text-align: center;
      font-size: 4.5vw;
    }

    .stars {
      background: no-repeat;
      background-size: contain;
      background-position: center center;
      height: 4vh;
      width: 50%;
      margin: auto;
      right: initial;
      display: block;
      z-index: 9999;
    }

    .stars-0 {
      background-image: url("../img/stars-0.svg"); }
    .stars-1 {
      background-image: url("../img/stars-1.svg"); }
    .stars-2 {
      background-image: url("../img/stars-2.svg"); }
    .stars-3 {
      background-image: url("../img/stars-3.svg"); }
    .stars-4 {
      background-image: url("../img/stars-4.svg"); }
    .stars-5 {
      background-image: url("../img/stars-5.svg"); }

    .city {
      padding-bottom: .5em;
    }

    .description {
      font-weight: 500;
    }

    .price {
      padding-top: .2em;
      font-size: 4.5vw;
    }
  }

  button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: block;
    background-color: $primary-color;
    font-family: 'Open Sans', sans-serif;
    width: auto;
    margin: auto;
    margin-top: 2vh;
    padding: .5em 2.2em .5em 2.2em;
    border-radius: 2em;
    font-size: 4vw;
    color: #fff;
    border: none;
  }
}

.divider {
  width: 100vw;
  height: 1px;
  display: block;
  position: absolute;
  top: 55vh;
  background-color: #ddd;
  z-index: 9999;
}

.second{
  top:64vh;
  z-index: 50;  

  figure{
    background-image: url('{{Offers[1].ImageUrl or ""}}');
  }
}

footer {
  background: white;
  top: 0;
  display: block;
  height: 12vh;
  width: 100vw;
  padding: .1px;
  position: absolute;
  bottom: 0vh;
  box-shadow: 0 0 1em #ddd;
  img {
    width: auto;
    height:6.5vh;
    display: block;
    position: absolute;
    transform: translate(-50%,-50%);
    top: 46%;
    left: 50%;
  }
}

`;

export const sassHorizontal = `
@media screen and (min-aspect-ratio: 300/100) {
  section {
    height: 100vh;
  }
  article, .second {
    background-size: contain;
    background-position: 15% center;
    height: 96vh;
    width: 78vw;
    top: 2vh;
    left: 22vw;
    background: #FAFAFA;

    figure{
      left:0;
      height:100vh;
      width:20vw;
      top:50%;
      transform: translateY(-50%);
    }

    header {
      left: 22vw;
      right: 0;
      width:54vw;
      height: 100vh;
      font-size: 18vh;
      text-align: center;
      line-height:18vh;
      top:50%;
      transform: translateY(-50%);

      .wrap {
        text-align: left;
        width: 100%;
        font-size: 14vh;
        top: 50%;
        transform: translateY(-50%);
        left: 0;

        .stars {
          height: 12vh;
          width: 60vh;
          margin: auto;
          right: initial;
          margin-left: 0;
          display: block;
          z-index: 9999;
        }

        .price {
          font-size: 18vh;
        }

        .description {
          width: 35vw;
        }

        button {
          position: absolute;
          top:50%;
          transform: translateY(-55%);
          font-size: 14vh;
          display: block;
          padding: .7em 1em;
          width: auto;
          right: 0;
          font-weight: 500;
        }
      }
    }
  }

  .divider {
    display: none;
  }

  .second{
    left: 22vw;
    width: 64vw;
    z-index: 1000;
    animation: blinking 3s linear infinite;
  }

  footer {
    height: 100vh;
    width: 22vw;
    top:0;
    left:0;
    border-bottom: none;
    border-right: 1px solid #eee;
    z-index:1000;

    img{
      width: 16vw;
      height: auto;
    }
  }
}
`

export const  sassInterstitialLandscape = `
@media screen and (min-aspect-ratio: 1/1) {

  section{
    height:100vh;
  }

  article {
    height:77vh;
    width: 45vw;
    top:20vh;
    left:3.333vw;

    figure{
      height:32vh;
      width: 45vh;
      left: 50%;
      transform: translateX(-50%);
    }


    header{
      top:36vh;
      left:0;
      height:50%;
      font-size: 3.2vw;
      text-align: center;
      line-height: 3.6vw;

      .wrap{
        width:100%;
        font-size: 3.2vw;
        width: 87%;

        .city {
          padding-bottom: .2em;
        }
        .price {
          padding-top: .5em;
          font-size: 3vw;
        }

        button{
          font-size: 4.5vh;
          display: block;
          margin: 2vh auto;
          padding: .5em 1.5em;
        } 
      }
    }
  }

  .divider {
  height: 84vh;
  width: 1px;
  top: 16vh;
  left: 50vw;
  }


  .second{
    top:20vh;
    left:51.666vw;
  }

  footer {
      height: 16vh;
    img {
      height: 10vh;
      width: auto;
      top: 46%;
      left: 50%;
    }
  }
}
`;

export const sassVariables = `
$primary-color: #0770CD;

@-webkit-keyframes blinking {
  0%   { opacity: 0; }
  49%   { opacity: 0; }
  50%  { opacity: 1;}
  100%  { opacity: 1;}
  
}
@-moz-keyframes blinking {
  0%   { opacity: 0; }
  49%   { opacity: 0; }
  50%  { opacity: 1;}
  100%  { opacity: 1;}
}
@-o-keyframes blinking {
  0%   { opacity: 0; }
  49%   { opacity: 0; }
  50%  { opacity: 1;}
  100%  { opacity: 1;}
}
@keyframes blinking {
  0%   { opacity: 0; }
  49%   { opacity: 0; }
  50%  { opacity: 1;}
  100%  { opacity: 1;}
}
`;